import classNames from 'classnames'
import * as React from 'react'

import ExpandHandle from '../VirtualizedTreeExpandHandle/VirtualizedTreeExpandHandle'

import styles from './VirtualizedTreeItem.css'

type Props = {
  style: React.CSSProperties
  className: string
  // for consistency with VirtualizedTreeOverlayItem
  wrapperClassName?: string
  containerClassName?: string
  contentClassName?: string
  expandable?: boolean
  expanded?: boolean
  indent: number
  children: React.ReactNode
  onToggleExpand?: () => unknown
  wrapperHtmlProps?: React.JSX.IntrinsicElements['div']
}

function VirtualizedTreeItem({
  style,
  className,
  containerClassName,
  wrapperClassName,
  contentClassName,
  children,
  expandable = false,
  expanded = false,
  indent,
  onToggleExpand,
  wrapperHtmlProps,
}: Props) {
  return (
    <div role="row" style={style} className={containerClassName}>
      <div
        {...wrapperHtmlProps}
        role="cell"
        className={classNames(styles.item, className, wrapperClassName)}
      >
        <ExpandHandle
          className={styles.expandHandle}
          expandable={expandable}
          expanded={expanded}
          indent={indent}
          onClick={onToggleExpand}
          tabIndex={-1}
        />
        <div className={classNames(styles.content, contentClassName)}>{children}</div>
      </div>
    </div>
  )
}

export default VirtualizedTreeItem
